import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import { MutationBlobStorageIntegrationCreateArgs } from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { CREATE_BLOB_STORAGE_INTEGRATION } from "./gql";

const useBlobStorageIntegrationCreate = createDefaultMutationHook(CREATE_BLOB_STORAGE_INTEGRATION);

const useCreateBlobStorageIntegration = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [blobStorageIntegrationCreate, { loading }] = useBlobStorageIntegrationCreate();

  const createBlobStorageIntegration = useCallback(
    (input: MutationBlobStorageIntegrationCreateArgs, successCallback?: () => void) => {
      blobStorageIntegrationCreate(input, (data) => {
        if (data?.blobStorageIntegrationCreate) {
          reportSuccess({
            message: `Integration ${data.blobStorageIntegrationCreate.name} was successfully created`,
          });
          successCallback?.();

          trackSegmentAnalyticsEvent("Blob Storage - Setup Finished", {
            labels: input.customInput?.labels?.length,
            space: input.customInput?.spaceID,
          });
        }
      });
    },
    [blobStorageIntegrationCreate, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    createBlobStorageIntegration,
    loading,
  };
};

export default useCreateBlobStorageIntegration;
